import { createContext, PropsWithChildren, useContext, useReducer } from 'react'
import { ordersDefault, ordersReducer } from './reducers'
import { OrdersContextType, UseOrdersContext } from './types'

const OrdersContext = createContext<OrdersContextType>({
  context: ordersDefault,
  updateContext: () => null,
})

export const useOrdersContext = (): UseOrdersContext => {
  const context = useContext<OrdersContextType>(OrdersContext)
  if (!context || !context.context) {
    throw new Error('useOrders should be used within OrdersContext')
  }
  return { ...context.context, updateContext: context.updateContext }
}

export const OrdersProvider = ({ children }: PropsWithChildren) => {
  const [context, updateContext] = useReducer(ordersReducer, ordersDefault)

  return (
    <OrdersContext.Provider value={{ context, updateContext }}>
      {children}
    </OrdersContext.Provider>
  )
}
